import React, { useEffect, useMemo, useRef, useState } from "react";
import DocumentMp4Viewer from "./DocumentMp4Viewer";

import DocumentPdfViewer from "./DocumentPdfViewer";
import DocumentStlViewer from "./DocumentStlViewer";

interface IDocumentViewerProps {
  onDismiss: any;
  title: string;
  path: string;
  stueliId?: string | undefined;
  productId?: string | undefined;
  addToBedarf?: any;
  canDownload: boolean;
}

function DocumentViewer(props: IDocumentViewerProps) {
  return (
    <>
      {props.path.toLowerCase().endsWith(".pdf") && (
        <DocumentPdfViewer
          onDismiss={() => props.onDismiss()}
          title={props.title}
          path={props.path}
          stueliId={props.stueliId}
          addToBedarf={props.addToBedarf}
          canDownload={props.canDownload}
        />
      )}
      {props.path.toLowerCase().endsWith(".mp4") && (
        <DocumentMp4Viewer
          onDismiss={props.onDismiss}
          title={props.title}
          path={props.path}
          stueliId={props.stueliId}
          addToBedarf={props.addToBedarf}
        />
      )}
      {props.path.toLowerCase().endsWith(".stl") && (
        <DocumentStlViewer
          onDismiss={props.onDismiss}
          title={props.title}
          path={props.path}
          stueliId={props.stueliId}
          addToBedarf={props.addToBedarf}
        />
      )}
    </>
  );
}

export default DocumentViewer;
